import { Gender } from 'interfaces/types'

import { BabyGrowthState } from './types'

export const babyGrowthInitialState: BabyGrowthState = {
  babyGrowthContent: null,
  babyGrowthResult: null,
  name: '',
  gender: Gender.Boy,
  birthday: new Date(),
  height: 0,
  weight: 0,
  head: 0,
  bmi: 0,
  measurementDate: new Date(),
  resultBasedOnRiskLevel: null,
  riskLevel: null,
  babyLists: [],
  isNewBaby: false,
  currentBaby: null,
}
